module.exports = __webpack_public_path__ + "img/193.bbd98fac.jpg";